module.exports = __webpack_public_path__ + "img/skills-lightning-sor-3.c528af90.png";